function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Header-/-Venue/White",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "building-select",
  stroke: "#FFFFFF",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0.25,
  y: 0.25,
  width: 29.5,
  height: 29.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0576923,29.4711538 L6.00961538,29.4711538 C5.71754172,29.4711538 5.48076923,29.2343814 5.48076923,28.9423077 L5.48076923,13.5096154 L16.0576923,13.5096154 L16.0576923,29.4711538 Z",
  id: "Shape",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.9423077,13.6057692 L13.9423077,5.04807692 L24.5192308,5.04807692 L24.5192308,28.9423077",
  id: "Shape"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Shape",
  points: "10.7692308 29.4711538 10.7692308 26.8269231 7.59615385 26.8269231 7.59615385 29.4711538"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Shape",
  points: "21.6346154 29.4711538 21.6346154 24.8557692 18.4615385 24.8557692 18.4615385 29.4711538"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.48076923,
  y1: 16.7788462,
  x2: 9.71153846,
  y2: 16.7788462,
  id: "Shape"
}), /*#__PURE__*/React.createElement("line", {
  x1: 13.9423077,
  y1: 11.4903846,
  x2: 18.1730769,
  y2: 11.4903846,
  id: "Shape"
}), /*#__PURE__*/React.createElement("line", {
  x1: 13.9423077,
  y1: 8.31730769,
  x2: 20.2884615,
  y2: 8.31730769,
  id: "Shape"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.48076923,
  y1: 19.9519231,
  x2: 7.59615385,
  y2: 19.9519231,
  id: "Shape"
})));
function SvgVenuePicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Header / Venue/White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenuePicker);
export default __webpack_public_path__ + "static/media/venue_picker.cd0515c2ee770e5d3a757fc945709bae.svg";
export { ForwardRef as ReactComponent };